<template>
  <div>
    <div
      class="d-flex flex-column"
      :class="{ 'mt-4': index > 0 }"
      v-for="(slotGroup, groupsKey, index) in groupedSlots"
      :key="index"
    >
      {{ groupsKey | longDayFormat }}
      <div>
        <v-chip
          class="selected-worker-chip mr-2"
          :key="slotIndex"
          v-for="(slot, slotIndex) in slotGroup"
        >
          <div>
            {{ slot.startTime | hourAndMinutes }} -
            {{ slot.endTime | hourAndMinutes }}
            <v-icon
              class="gray"
              @click.native="() => removeSlot(slot)"
              v-if="showRemoveButton"
            >
              mdi-close
            </v-icon>
          </div>
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
import { LONG_DATE_FORMAT, BASE_DATE_FORMAT } from "@/constants/common.js";
import { groupByDate } from "@/utils/helpers";
import { formatDate } from "@/utils/time";
import { sortBy } from "lodash";

export default {
  name: "GroupedSlotList",
  props: {
    slots: {
      type: Array,
      required: true
    },
    showRemoveButton: Boolean
  },
  computed: {
    groupedSlots() {
      const sortedSlots = sortBy(this.slots, "startTime");
      return groupByDate({
        items: sortedSlots,
        key: "startTime"
      });
    }
  },
  methods: {
    removeSlot(slotData) {
      this.$emit("onRemoveSlot", slotData);
    }
  },
  filters: {
    longDayFormat(date) {
      return formatDate({
        date,
        startFormat: BASE_DATE_FORMAT,
        endFormat: LONG_DATE_FORMAT
      });
    }
  }
};
</script>

<style lang="scss"></style>
